import clsx from "clsx";

export interface NavHeaderProps {
  children: React.ReactNode;
  className?: string;
  px?: string;
  gap?: string;
}

export function NavHeader(props: NavHeaderProps) {
  const { children, className = "flex sm:flex-row sm:gap-0", px = "px-4", gap = "gap-2" } = props;

  return (
    <div
      className={clsx(
        "flex-col justify-between pb-4 border-b border-extra-light sm:px-0",
        className,
        px,
        gap
      )}
    >
      {children}
    </div>
  );
}

export default NavHeader;
